import type { SearchMatches } from 'widgets/sports-menu-widget/model/types';

import { ResultGroup } from '../ResultGroup';

import { TXTWCL_Events } from './EventsResultGroup.messages.json';

interface Props {
  events: SearchMatches['events'];
}
export const EventsResultGroup = ({ events }: Props) => (
  <ResultGroup resultsGroup={events} titleTranslationTag={TXTWCL_Events} />
);
